import { NgModule } from '@angular/core';
// V16
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDividerModule } from '@angular/material/divider';
import { DomSanitizer } from '@angular/platform-browser';
import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import { MatChipsModule } from '@angular/material/chips';

@NgModule({
  exports: [
    //V16
    MatAutocompleteModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatMenuModule,
    MatListModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSidenavModule,
    MatInputModule,
    MatTableModule,
    MatToolbarModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatCardModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatSnackBarModule,
    MatDividerModule,
    MatSortModule,
    MatChipsModule,
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-AR' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
})
export class MaterialModule {
  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
  ) {
    this.iconRegistry.addSvgIcon(
      'animal',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/animal.svg'),
    );
    this.iconRegistry.addSvgIcon(
      'caravana',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/caravana.svg'),
    );
    this.iconRegistry.addSvgIcon(
      'comedero',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/comedero.svg'),
    );
    this.iconRegistry.addSvgIcon(
      'claro-oscuro',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/svg/claro-oscuro.svg',
      ),
    );
    this.iconRegistry.addSvgIcon(
      'animales',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/animales.svg'),
    );
    this.iconRegistry.addSvgIcon(
      'cisternas',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/cisternas.svg'),
    );
    this.iconRegistry.addSvgIcon(
      'comederos',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/comederos.svg'),
    );
    this.iconRegistry.addSvgIcon(
      'bombeos',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/bombeos.svg'),
    );
    this.iconRegistry.addSvgIcon(
      'meteorologicas',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/svg/meteorologicas.svg',
      ),
    );
    this.iconRegistry.addSvgIcon(
      'freatimetros',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/svg/freatimetros.svg',
      ),
    );
    this.iconRegistry.addSvgIcon(
      'pozos',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/pozos.svg'),
    );
    this.iconRegistry.addSvgIcon(
      'shss',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/shss.svg'),
    );
    this.iconRegistry.addSvgIcon(
      'lanza-humedad',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/svg/lanza-humedad.svg',
      ),
    );
    this.iconRegistry.addSvgIcon(
      'laminas',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/laminas.svg'),
    );
    this.iconRegistry.addSvgIcon(
      'canales',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/canales.svg'),
    );
    this.iconRegistry.addSvgIcon(
      'pluviometros',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/svg/pluviometros.svg',
      ),
    );
    this.iconRegistry.addSvgIcon(
      'silobolsas',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/svg/silobolsas.svg',
      ),
    );
    this.iconRegistry.addSvgIcon(
      'luminariaEncendida',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/encendida.svg'),
    );
    this.iconRegistry.addSvgIcon(
      'luminariaEncendidaErr',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/svg/encendidaErr.svg',
      ),
    );
    this.iconRegistry.addSvgIcon(
      'luminariaApagadaErr',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/svg/apagadaErr.svg',
      ),
    );
    this.iconRegistry.addSvgIcon(
      'luminariaApagada',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/apagada.svg'),
    );
    this.iconRegistry.addSvgIcon(
      'luminariaIndeterminado',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/svg/indeterminado.svg',
      ),
    );
    this.iconRegistry.addSvgIcon(
      'light_mode',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/svg/light_mode.svg',
      ),
    );
    this.iconRegistry.addSvgIcon(
      'dark_mode',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/dark_mode.svg'),
    );
    this.iconRegistry.addSvgIcon(
      'battery',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/battery.svg'),
    );
    this.iconRegistry.addSvgIcon(
      'caudal',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/caudal.svg'),
    );
    this.iconRegistry.addSvgIcon(
      'presion-agua',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/caudal.svg'),
    );
    this.iconRegistry.addSvgIcon(
      'tendencia',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/tendencia.svg'),
    );
  }
}
